import React from 'react';
import { graphql, Link } from 'gatsby';
import SEO from '../components/SEO';
import HeroSection from '../components/HeroSection';
import GetSEOData from '../data/SEO';
import { useState, useEffect } from 'react';
import IncidentCard from '../components/statuspage/IncidentCard';
import Spinner from '../components/order/Spinner';
import BadgeHeroSection from '../components/HeroSectionBadge';
import OrderJourneyContact from '../components/OrderJourneyContact';
import LitImage from '../components/images/LitImage';
const StatusPage = ({ data }) => {
  const [incidents, setIncidents] = useState(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!incidents) {
      setIncidents([]);
      setLoading(true);
      fetch(`${process.env.GATSBY_NETWORK_API_URL}/api/status/all`, {
        headers: {
          'x-functions-key': process.env.GATSBY_NETWORK_STATUS_APIKEY,
        },
      })
        .then((response) => response.json())
        .then((result) => {
          // Sorts incidents by updated date - latest first
          if (Array.isArray(result)) {
            const sortedIncidents = result.sort((a, b) => {
              const aDate = new Date(a.lastUpdated);
              const bDate = new Date(b.lastUpdated);
              return aDate > bDate ? -1 : 1;
            });
            setIncidents(sortedIncidents);
          }
        })
        .finally(() => setLoading(false));
    }
  });

  const { title, description } = GetSEOData('status');

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      dateStyle: 'short',
      timeStyle: 'short',
    });
  };

  return (
    <div className="bootstrap">
      <div className="network-status-container">
        <SEO title={title} description={description} />
        <div className="network-status-hero">
          <div className="network-status-hero-inner">
            <h1>Network Status</h1>
            <div className="network-status-hero-image">
              <LitImage image={data.wifiBlue} />
            </div>
          </div>
        </div>
        <div className="network-status-incidents-container">
          <div className="network-status-incidents-inner">
            {!loading && incidents?.length > 0 && <h3>Current Incidents</h3>}
            {loading && <Spinner />}
            {!loading &&
              incidents?.map(({ name, status, updates, impact }) => {
                return (
                  <div className="network-status-incidents-content-dot-line-container">
                    <div className="network-status-incidents-dot-line">
                      <div className="network-status-incidents-dot">
                        <LitImage
                          image={
                            impact === 'minor'
                              ? data.statusDotAmber
                              : impact === 'major'
                              ? data.statusDotRed
                              : data.statusDotGreen
                          }
                          alt="coloured dot"
                        />
                      </div>
                      <div className="network-status-incidents-line">
                        <LitImage
                          image={data.statusLine}
                          alt="grey vertical line"
                        />
                      </div>
                    </div>
                    <div className="network-status-incidents-content">
                      <h5>Incident: {name}</h5>
                      <h6>Current incident status: {status}</h6>
                      <p>Incident updates:</p>
                      {updates.map(({ created, body }) => {
                        return (
                          <div className="network-status-incident">
                            <p className="network-status-created">
                              {formatDate(created)}
                            </p>
                            <p className="network-status-body">{body}</p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            {!loading && incidents?.length <= 0 && (
              <div className="network-status-no-incidents">
                <h3>All services are running normally</h3>
              </div>
            )}
          </div>
        </div>{' '}
        <div className="network-status-contact">
          <div className="network-status-contact-inner">
            <h4>Having trouble and it's not listed here?</h4>
            <p>
              Our customer support team are ready to help - get in touch on{' '}
              <a href="tel:03304604610">03304604610</a> or click the button
              below
            </p>
            <Link to="/contact-us" className="button-blue">
              Contact us
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export const query = graphql`
  query {
    statusLine: file(relativePath: { eq: "service-images/statusLine.png" }) {
      name
      relativePath
      childImageSharp {
        gatsbyImageData(
          quality: 75
          placeholder: BLURRED
          layout: CONSTRAINED
          formats: [AUTO, WEBP, AVIF]
        )
      }
      extension
      publicURL
    }
    statusDotAmber: file(
      relativePath: { eq: "service-images/statusDotAmber.png" }
    ) {
      name
      relativePath
      childImageSharp {
        gatsbyImageData(
          quality: 75
          placeholder: BLURRED
          layout: CONSTRAINED
          formats: [AUTO, WEBP, AVIF]
        )
      }
      extension
      publicURL
    }
    statusDotGreen: file(
      relativePath: { eq: "service-images/statusDotGreen.png" }
    ) {
      name
      relativePath
      childImageSharp {
        gatsbyImageData(
          quality: 75
          placeholder: BLURRED
          layout: CONSTRAINED
          formats: [AUTO, WEBP, AVIF]
        )
      }
      extension
      publicURL
    }
    statusDotRed: file(
      relativePath: { eq: "service-images/statusDotRed.png" }
    ) {
      name
      relativePath
      childImageSharp {
        gatsbyImageData(
          quality: 75
          placeholder: BLURRED
          layout: CONSTRAINED
          formats: [AUTO, WEBP, AVIF]
        )
      }
      extension
      publicURL
    }
    wifiBlue: file(relativePath: { eq: "service-images/wifiBlue.png" }) {
      name
      relativePath
      childImageSharp {
        gatsbyImageData(
          quality: 75
          placeholder: BLURRED
          layout: CONSTRAINED
          formats: [AUTO, WEBP, AVIF]
        )
      }
      extension
      publicURL
    }
  }
`;

export default StatusPage;
